import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableFooter,
  TablePagination,
  Menu,
  MenuItem,
  Checkbox,
} from '@material-ui/core';
import { AddCircle, DragIndicator, MoreHoriz, RemoveCircle } from '@material-ui/icons';
import CreateIcon from '@material-ui/icons/Create';
import TablePaginationActions from '../../../../../shared/table-pagination/TablePaginationActions';
import DeletePopupModel from '../../../../../shared/delete-popup/Delete-Popup';
import { SPA_INFO_VIEW, SPA_INFO_CREATE, SPA_INFO_EDIT } from '../../../../../constants/SpaConst';
import {
  RBAC_PERMISSION_LEVEL_FULL_ACCESS,
  RBAC_TYPE_HOTEL_SPA,
} from '../../../../../constants/RoleConsts';
import { useSelector, useDispatch } from 'react-redux';
import { allSpaInfoSelector, fetchAllSpa, setAllSpaInfo } from '../../../../property/propertySlice';
import LinearProgressBar from '../../../../../shared/progress-bar/Progress';
import {
  changeSpaInfoStatus,
  createDataSortMapping,
  deleteSpaDetails,
} from '../../../../../utils/PropertyAPIUtils';
import { notificationManager } from '../../../../../utils/NotificationUtils';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import useOutsideAlerter from '../../../../../custom-hooks/useOutsideAlerter';
import { handleOnDragEnd } from '../../../../../shared/custom-dragdrop/dragDrop';
import SearchBar from '../../../../../shared/search-bar/Search-Bar';
import MultipleDeleteConfirmationPopup from '../../../../../shared/MultiActionPopUp/MultiDeleteConfirmationPopup';
import {
  deleteSelectedItems,
  updateSelectedItemsStatus,
} from '../../../../../utils/ServicesAPIUtils';
import {
  PARTIAL_CHECKBOX_GREEN,
  ResetFilterList,
  getCheckedIds,
  isDragDisabled,
  updateCheckedStatus,
  updateSelectedModule,
} from '../../../../../utils/formUtils';
import { generateConfirmationMessage } from '../../../../../utils/formUtils';
import BulkActionCheckBox from '../../../../../shared/MultiActionPopUp/BulkActionCheckBox';
import MultipleSelectionAlert from '../../../../../shared/MultiActionPopUp/MultipleSelectionAlert';
import { decryptLocalStorage } from '../../../../../utils/authUtils';
import { stepDownLoaderCount, stepUpLoaderCount } from '../../../../../utils/loaderSlice';

const SpaInfoList = (props) => {
  const {
    onDrawerToggle,
    onViewToggle,
    selectedHotel,
    permissions,
    page,
    rowsPerPage,
    onsetRowsPerPage,
    onsetPage,
  } = props;

  const originalSpaInfo = useSelector(allSpaInfoSelector);
  const [spaInfo, setSpaInfo] = useState([]);
  const [loading, setLoading] = useState(true);
  const dispatch = useDispatch();
  const [selectedValue, setSelectedValue] = useState({
    id: '',
    name: '',
    title: '',
    description: '',
    status: false,
    anchorEl: null,
    spaInfo: null,
  });
  const [popUp, setPopUp] = useState(false);
  const [visible, setVisible] = useState(false);
  const wrapperRef = useRef(null);
  const prevHotelIdRef = useRef(selectedHotel);
  const [searchText, setSearchText] = useState('');
  const [showMultipleDeleteConfirmation, setShowMultipleDeleteConfirmation] = useState(false);
  const [actionName, setActionName] = useState(false);
  const [showBulkActiveDeactiveConfirmation, setShowBulkActiveDeactiveConfirmation] =
    useState(false);
  const [showBulkKebabSelectionAlert, setShowBulkKebabSelectionAlert] = useState(false);
  const [actionMenuList, setActionMenuList] = useState([]);
  const [isActive, setIsActive] = useState(false);
  const [isAllSelected, setIsAllSelected] = useState(false);

  useEffect(() => {
    setSearchText('');
    setSpaInfo(
      originalSpaInfo?.map((spaInfo) => {
        return {
          ...spaInfo,
          isChecked: false,
        };
      }),
    );
    setLoading(false);
  }, [originalSpaInfo]);

  useEffect(() => {
    updateSelectedModule(spaInfo, setActionMenuList, setIsAllSelected);
  }, [spaInfo]);

  useEffect(() => {
    if (loading || spaInfo?.length) return;
    const totalItems = spaInfo?.length;
    const maxPageIndex = Math.max(Math.ceil(totalItems / rowsPerPage) - 1, 0);
    if (page > maxPageIndex) {
      onsetPage(maxPageIndex);
    }
  }, [spaInfo?.length, rowsPerPage, page, onsetPage]);

  useEffect(() => {
    if (prevHotelIdRef?.current !== selectedHotel) {
      onsetPage(0);
    }
    prevHotelIdRef.current = selectedHotel;
  }, [selectedHotel]);

  const checkedSpaInfoItems = spaInfo?.filter((sInfo) => sInfo?.isChecked);

  const selectedcheckedSpaInfoListLength = checkedSpaInfoItems?.length;
  const listOfSpaInfoIds = checkedSpaInfoItems?.map((item) => item?.id);

  const hanldeSearchText = (searchText) => {
    setSearchText(searchText);
    const checkedIdList = getCheckedIds(spaInfo, 'isChecked');
    const filteredRows = originalSpaInfo.filter((item) => {
      return item.name.toLowerCase().includes(searchText.toLowerCase());
    });
    const updatedCheckedList = updateCheckedStatus(filteredRows, checkedIdList);
    onsetPage(0);
    setSpaInfo(updatedCheckedList);
  };

  const handleChangePage = (event, newPage) => {
    onsetPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    onsetRowsPerPage(parseInt(event.target.value, 10));
    onsetPage(0);
  };

  const onOpenDrawer = (event, type) => {
    if (selectedcheckedSpaInfoListLength) {
      setSpaInfo(ResetFilterList);
    }
    event.stopPropagation();
    onDrawerToggle(type, true, selectedValue.spaInfo);
    handleClose();
  };

  const handleClose = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      spaInfo: null,
    });
  };

  const handleCellMenuClick = (event, spaInfoItem) => {
    event.stopPropagation();
    if (selectedcheckedSpaInfoListLength > 1) {
      setShowBulkKebabSelectionAlert(true);
    } else {
      setSelectedValue({
        id: spaInfoItem.id,
        name: spaInfoItem.name,
        title: '',
        description: '',
        status: false,
        anchorEl: event.currentTarget,
        spaInfo: spaInfoItem,
      });
    }
  };

  const deleteSpaInfo = async (e) => {
    e.preventDefault();
    setSelectedValue((prev) => ({
      ...prev,
      title: 'Are you sure you want to delete',
      description:
        'This action cannot be reversed. Information associated with this spa will also be lost',
      status: true,
      anchorEl: null,
    }));
  };

  const deleteSpaInfoAPICall = async () => {
    try {
      const lang = decryptLocalStorage('lang');
      const delByLang = lang !== 'en' ? lang : '';
      if (selectedHotel && selectedValue && selectedValue.id) {
        await deleteSpaDetails(selectedValue.id, selectedHotel, delByLang);
        dispatch(fetchAllSpa(selectedHotel));
        notificationManager('success', 'Spa deleted successfully');
      }
      handleClose();
    } catch (e) {
      if (e.graphQLErrors) {
        notificationManager('danger', e.graphQLErrors[0].message);
      } else {
        notificationManager('danger', 'Failed to delete Spa');
      }
      handleClose();
    }
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  const onDeleteCancel = () => {
    setSelectedValue({
      id: '',
      name: '',
      title: '',
      description: '',
      status: false,
      anchorEl: null,
      spaInfo: null,
    });
  };

  const onViewDetails = (spaInfoItem, e) => {
    if (e?.target?.tagName === 'TD') {
      onViewToggle(SPA_INFO_VIEW, true, spaInfoItem);
    }
  };

  const onClickView = (e) => {
    if (selectedValue && selectedValue.spaInfo) {
      onViewToggle(SPA_INFO_VIEW, true, selectedValue.spaInfo);
    }
  };

  const onChangeStatus = async (e, payload) => {
    e.stopPropagation();
    const lang = decryptLocalStorage('lang');
    const selectedLang = lang !== 'en' ? lang : '';
    try {
      const item = { ...payload };
      item.isActive = !payload.isActive;

      await changeSpaInfoStatus(selectedHotel, item.id, item.isActive, selectedLang);
      notificationManager(
        'success',
        item.isActive ? 'Spa activated successfully' : 'Spa deactivated successfully',
      );
      dispatch(fetchAllSpa(selectedHotel));
    } catch (e) {
      if (e.graphQLErrors) {
        notificationManager('danger', e.graphQLErrors[0].message);
      } else {
        notificationManager('danger', 'Failed');
      }
    }
    handleClose(e);
    setIsAllSelected(false);
    setActionMenuList([]);
  };

  useOutsideAlerter(wrapperRef, visible, setPopUp);

  const handleSelectAll = (event) => {
    let selectedSpaList = [];
    let actionListName = [];
    const CheckedValue = event?.target?.checked;
    setIsAllSelected(CheckedValue);
    selectedSpaList = spaInfo?.map((item) => {
      return {
        ...item,
        isChecked: CheckedValue,
      };
    });

    const isActive = selectedSpaList?.some((restaurant) => restaurant?.isActive);
    const isInactive = selectedSpaList?.some((restaurant) => !restaurant?.isActive);

    if (isActive && !actionListName?.includes('Deactivate')) {
      actionListName.push('Deactivate');
    }
    if (isInactive && !actionListName?.includes('Activate')) {
      actionListName.push('Activate');
    }
    setSpaInfo([...selectedSpaList]);

    const sortActionMenuList = actionListName.sort((a, b) => {
      const order = { Activate: 1, Deactivate: 2, Delete: 3 };
      return order[a] - order[b];
    });

    setActionMenuList(sortActionMenuList);

    if (!event?.target?.checked && !selectedSpaList?.some((item) => item?.isChecked)) {
      setActionMenuList([]);
    }
  };

  const handleAction = (actionName) => {
    let selectedValue = spaInfo?.filter((SInfo) => SInfo?.isChecked);
    switch (actionName) {
      case 'Delete':
        if (selectedValue?.length > 0) {
          setShowMultipleDeleteConfirmation(true);
          setActionName('delete');
        }
        break;
      case 'Activate':
        if (selectedValue?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('activate');
          setIsActive(true);
        }
        break;
      case 'Deactivate':
        if (selectedValue?.length > 0) {
          setShowBulkActiveDeactiveConfirmation(true);
          setActionName('deactivate');
          setIsActive(false);
        }
        break;
      default:
        break;
    }
  };

  const onApiCallConfirmationNotification = generateConfirmationMessage(
    'Spa',
    listOfSpaInfoIds?.length,
    isActive,
  );

  const handleMultipleStatusChange = async () => {
    handleClose();
    setActionMenuList([]);
    try {
      dispatch(stepUpLoaderCount());
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'SPA';
      await updateSelectedItemsStatus(
        listOfSpaInfoIds,
        selectedHotel,
        selectedLang,
        moduleName,
        '',
        isActive,
        searchText?.length > 0 ? false : isAllSelected,
      );
      dispatch(fetchAllSpa(selectedHotel));
      notificationManager('success', onApiCallConfirmationNotification);
      setSelectedValue({
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        activate: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'The status of the Spa was not changed',
      );
    } finally {
      dispatch(stepDownLoaderCount());
    }

    setIsAllSelected(false);
    setSpaInfo(ResetFilterList);
  };

  const deleteMultipleSelection = async () => {
    handleClose();
    try {
      const lang = decryptLocalStorage('lang');
      const selectedLang = lang !== 'en' ? lang : '';
      const moduleName = 'SPA';
      await deleteSelectedItems(
        listOfSpaInfoIds,
        selectedHotel,
        selectedLang,
        moduleName,
        '',
        isAllSelected,
      );
      dispatch(fetchAllSpa(selectedHotel));
      notificationManager('success', 'Spa deleted successfully');
      setSelectedValue({
        ...selectedValue,
        id: '',
        name: '',
        title: '',
        description: '',
        status: false,
        brand: null,
      });
    } catch (e) {
      notificationManager(
        'danger',
        e.graphQLErrors ? e.graphQLErrors[0].message : 'Failed to delete Spa',
      );
    }
    setIsAllSelected(false);
    setActionMenuList([]);
    setSpaInfo(ResetFilterList);
  };

  const handleCheckboxChange = (id) => {
    let actionListName = [];
    let actionList = [];
    let index = spaInfo?.findIndex((sInfo) => sInfo.id === id);
    if (!spaInfo[index]?.isChecked) {
      spaInfo[index] = { ...spaInfo[index], isChecked: true };
    } else {
      spaInfo[index].isChecked = !spaInfo[index]?.isChecked;
    }
    setSpaInfo([...spaInfo]);

    actionList = spaInfo?.filter((sInfo) => sInfo?.isChecked).map((status) => status?.isActive);

    const checkedItems = spaInfo?.filter((sInfo) => sInfo?.isChecked);

    if (checkedItems.length === 0) {
      setActionMenuList([]);
      setIsAllSelected(false);
      return;
    }

    const isActiveSelected = actionList.includes(true);
    const isInactiveSelected = actionList.includes(false);

    if (isActiveSelected && isInactiveSelected) {
      actionListName.push('Activate', 'Deactivate');
    } else if (isActiveSelected) {
      actionListName.push('Deactivate');
    } else if (isInactiveSelected) {
      actionListName.push('Activate');
    }
    const isAllSelected = spaInfo?.every((sInfo) => sInfo?.isChecked);
    setIsAllSelected(isAllSelected);

    setActionMenuList(actionListName);
  };

  const dragDisabled = isDragDisabled(spaInfo, searchText);

  return (
    <div className='mt-4 mb-4 group-list-container'>
      {selectedValue.id && selectedValue.status === true && (
        <DeletePopupModel
          deletePopUp={selectedValue}
          onDelete={deleteSpaInfoAPICall}
          onDeleteCancel={onDeleteCancel}
        />
      )}

      {showMultipleDeleteConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedcheckedSpaInfoListLength} ${
            selectedcheckedSpaInfoListLength > 1 ? 'Spas' : 'Spa'
          } will be ${actionName}d. This Action is irreversible.`}
          isOpen={showMultipleDeleteConfirmation}
          onClose={() => setShowMultipleDeleteConfirmation(false)}
          onConfirm={() => {
            deleteMultipleSelection();
          }}
          leftButtonName={'Cancel'}
          rightButtonName={'Delete'}
        />
      )}

      {showBulkActiveDeactiveConfirmation && (
        <MultipleDeleteConfirmationPopup
          title={`Are you sure you want to ${actionName} this selection?`}
          subTitle={`A selection of ${selectedcheckedSpaInfoListLength}  ${
            selectedcheckedSpaInfoListLength > 1 ? 'Spas' : 'Spa'
          } will be ${actionName}d.`}
          isOpen={showBulkActiveDeactiveConfirmation}
          onClose={() => setShowBulkActiveDeactiveConfirmation(false)}
          onConfirm={() => {
            handleMultipleStatusChange();
          }}
          leftButtonName={'No'}
          rightButtonName={'Yes'}
        />
      )}

      <SearchBar
        type={SPA_INFO_CREATE}
        buttonName='Add Spa'
        displayAddOrEdit={
          permissions[RBAC_TYPE_HOTEL_SPA] === RBAC_PERMISSION_LEVEL_FULL_ACCESS ? 'show' : 'hide'
        }
        onOpenDrawer={onOpenDrawer}
        setSearchText={hanldeSearchText}
        visible={visible}
        setVisible={setVisible}
        popUp={popUp}
        setPopUp={setPopUp}
        placeHolder={spaInfo}
        setPlaceHolder={setSpaInfo}
        globalPlaceHolder={originalSpaInfo}
        setGlobalPlaceHolder={setAllSpaInfo}
        dispatch={dispatch}
        mappingApi={createDataSortMapping}
        displayText='Spa info'
        module='SPA'
        searchText={searchText}
        actionMenuItems={actionMenuList ?? []}
        handleAction={handleAction ?? false}
        setSearch={setSearchText}
      />

      <div ref={wrapperRef} className='row mx-2 d-flex mt-4'>
        {loading ? (
          <div className='pt-4 col-md-12'>
            <LinearProgressBar />
          </div>
        ) : (
          spaInfo && (
            <TableContainer>
              <Table className='list-table' aria-label='simple table'>
                <TableHead>
                  <TableRow>
                    <TableCell className={`w-5 ${dragDisabled ? '' : 'ps-5'}`}>
                      <BulkActionCheckBox
                        onChange={handleSelectAll}
                        checked={isAllSelected || false}
                        selectedLength={selectedcheckedSpaInfoListLength}
                        totalLength={originalSpaInfo?.length}
                        inputProps={{
                          'aria-label': 'select all Spa Info',
                        }}
                        className={PARTIAL_CHECKBOX_GREEN}
                      />
                    </TableCell>
                    <TableCell className='w-40'>Name</TableCell>
                    <TableCell className='w-50'>Spa Code</TableCell>
                    <TableCell className='w-30' align='center'>
                      Status
                    </TableCell>
                    <TableCell align='right'></TableCell>
                  </TableRow>
                </TableHead>
                <DragDropContext
                  onDragEnd={(event) =>
                    handleOnDragEnd(
                      event,
                      setVisible,
                      spaInfo,
                      setSpaInfo,
                      false,
                      page,
                      rowsPerPage,
                    )
                  }
                  isDropDisabled={dragDisabled}
                >
                  <Droppable droppableId='spas' isDropDisabled={dragDisabled}>
                    {(provided) => (
                      <TableBody {...provided.droppableProps} ref={provided.innerRef}>
                        {(rowsPerPage > 0
                          ? spaInfo.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                          : spaInfo
                        ).map((spaInfoItem, i) => (
                          <Draggable
                            key={spaInfoItem.id}
                            draggableId={spaInfoItem.id}
                            index={i}
                            isDragDisabled={dragDisabled}
                          >
                            {(provided) => (
                              <TableRow
                                key={i}
                                className='border-white pointer'
                                onClick={(e) => {
                                  onViewDetails(spaInfoItem, e);
                                }}
                                ref={provided.innerRef}
                                {...provided.draggableProps}
                                {...provided.dragHandleProps}
                              >
                                <TableCell className='w-12'>
                                  {!dragDisabled && (
                                    <span style={{ marginRight: 1.5 }}>
                                      <DragIndicator className='res-menu-accordion-drag' />
                                    </span>
                                  )}
                                  <Checkbox
                                    onChange={(event) => handleCheckboxChange(spaInfoItem?.id)}
                                    checked={spaInfoItem?.isChecked || false}
                                    inputProps={{
                                      'aria-label': `select spaInfoItem ${spaInfoItem?.id}`,
                                    }}
                                  />
                                </TableCell>
                                <TableCell className='w-40'>{spaInfoItem?.name}</TableCell>
                                <TableCell className='w-50'>{spaInfoItem?.code}</TableCell>
                                <TableCell className='w-30 text-center'>
                                  <div className='d-flex justify-content-center'>
                                    <div
                                      className={`pill d-flex justify-content-center align-items-center ${
                                        spaInfoItem?.isActive
                                          ? 'pill-active'
                                          : 'pill-inactive theme-dark-green'
                                      }`}
                                    >
                                      <span className='ms-1'>
                                        {spaInfoItem?.isActive ? 'Active' : 'Inactive'}
                                      </span>
                                    </div>
                                  </div>
                                </TableCell>
                                <TableCell align='right'>
                                  {permissions[RBAC_TYPE_HOTEL_SPA] ===
                                    RBAC_PERMISSION_LEVEL_FULL_ACCESS && (
                                    <Button
                                      aria-controls='simple-menu'
                                      aria-haspopup='true'
                                      onClick={(e) => {
                                        handleCellMenuClick(e, spaInfoItem);
                                      }}
                                      className='showpopupInner'
                                    >
                                      <MoreHoriz className='showpopupInner' />
                                    </Button>
                                  )}
                                  <Menu
                                    id={i}
                                    anchorEl={selectedValue?.anchorEl}
                                    disableRestoreFocus
                                    MenuListProps={{ autoFocusItem: false }}
                                    keepMounted
                                    open={
                                      Boolean(selectedValue.anchorEl) &&
                                      selectedValue.id === spaInfoItem.id
                                    }
                                    onClose={handleClose}
                                    className='shadow'
                                  >
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onChangeStatus(e, selectedValue.spaInfo);
                                      }}
                                    >
                                      {selectedValue.spaInfo?.isActive === true ? (
                                        <>
                                          <RemoveCircle className='me-2 action-menu-icon' />
                                          Deactivate
                                        </>
                                      ) : (
                                        <>
                                          <AddCircle className='me-2 action-menu-icon' />
                                          Activate
                                        </>
                                      )}
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onOpenDrawer(e, SPA_INFO_EDIT);
                                      }}
                                    >
                                      <CreateIcon className='me-2 action-menu-icon' />
                                      Edit
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        onClickView(e);
                                      }}
                                    >
                                      <VisibilityIcon className='me-2 action-menu-icon' />
                                      View
                                    </MenuItem>
                                    <MenuItem
                                      className='pe-4'
                                      onClick={(e) => {
                                        deleteSpaInfo(e);
                                      }}
                                    >
                                      <DeleteForeverIcon className='me-2 action-menu-icon' />
                                      Delete
                                    </MenuItem>
                                  </Menu>
                                </TableCell>
                              </TableRow>
                            )}
                          </Draggable>
                        ))}
                        {provided.placeholder}
                      </TableBody>
                    )}
                  </Droppable>
                </DragDropContext>
                <TableFooter>
                  <TableRow className='paginator'>
                    <TablePagination
                      rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                      count={spaInfo.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      SelectProps={{
                        inputProps: { 'aria-label': 'rows per page' },
                        native: true,
                      }}
                      onPageChange={handleChangePage}
                      onRowsPerPageChange={handleChangeRowsPerPage}
                      ActionsComponent={TablePaginationActions}
                    />
                  </TableRow>
                </TableFooter>
              </Table>
            </TableContainer>
          )
        )}
        {showBulkKebabSelectionAlert && (
          <MultipleSelectionAlert
            isOpen={showBulkKebabSelectionAlert}
            onClose={() => setShowBulkKebabSelectionAlert(false)}
            message='Please select one item from the list that you want to edit.'
            centerButtonName='OK'
          />
        )}
      </div>
    </div>
  );
};

export default SpaInfoList;
